<template>
    <div class="Error">
        <div class="widthStye">
            <div class="errorstyle">
                <div>
                    <p class="title">404</p>
                    <p>您的页面不见了~</p>
                </div>
                <p>
                    <span id="counts">5</span>秒后将跳转至首页</p>
                <span class="span1" @click="btn()">返回上一页</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            timer:null//创建一个变量用于存放计时器的返回值
        }
    },
    mounted() {
        this.count();
    },
    methods: {
        count() {
            var counts = document.getElementById("counts");
            var num = counts.innerHTML;
            var _self = this;
           clearInterval(_self.timer);			//开始之前清除上一次的计时器
            _self.timer = setInterval(function(){	//获取计时器的返回值，用于清除用
                var a = counts.innerHTML;		//获取标签的值，用于--
                if (a == 1) {					//判断停止条件
                    clearInterval(_self.timer);	//满足条件的时候停止计时器
                    _self.$router.push({ path: "/main/home" });
                } else {
                    a--;					//不满足条件的时候，--
                }
                counts.innerHTML = a			//把处理之后的值，再还给元素
            }, 1000)//每隔一秒执行一次
        },
        btn(){
            clearInterval(this.timer);
            window.history.go(-1)
        }
    }
}
</script>

<style scoped>
.Error {
    background: #fff;
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 9999;
}
.title{
    font-size: 5rem;
    margin-bottom: 4rem;
}
.widthStye {
    padding-top: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.errorstyle {
    margin: 0 auto;
}
.errorstyle p {
    color: #aaa;
    width: 100%;
    text-align: center;
    margin-top: 10px;
}
.errorstyle .span1 {
    display: block;
    margin: 20px auto;
    line-height: 42px;
    text-align: center;
    width: 137px;
    height: 42px;
    cursor: pointer;
    background: rgba(66,153,35,1);
    border-radius: 8px;
    color: #fff;
    margin-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Error.vue